module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "object-card",
    attrs: {
      "header-tag": "header",
      "footer-tag": "footer"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('a', {
    attrs: {
      "href": _vm.objectviewUrl
    }
  }, [_c('div', {
    staticClass: "image",
    style: (("background-image: url(" + _vm.imagePath + ");"))
  })]), _vm._v(" "), (!_vm.markedForDeletion) ? _c('div', {
    staticClass: "checkbox_"
  }, [_c('b-form-checkbox', {
    staticClass: "_input",
    attrs: {
      "plain": "",
      "checked": _vm.isChecked
    },
    on: {
      "change": function($event) {
        _vm.handleCheckClick(_vm.objectId, $event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [(_vm.isVisitable) ? _c('erco-dropdown', {
    attrs: {
      "size": "sm",
      "items": _vm.actionSelectionItems,
      "label": "Ansehen",
      "useLabelInline": true
    },
    on: {
      "change": _vm.handleActionSelectionChange
    }
  }) : _vm._e(), _vm._v(" "), _c('erco-status-badge', {
    staticClass: "badge float-right",
    attrs: {
      "status": _vm.computedStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('div', {
    staticClass: "cms-structure-info"
  }, [_c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.category))]), _vm._v(" "), _c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.specification))]), _vm._v(" "), _c('div', {
    staticClass: "_item"
  }, [_vm._v(_vm._s(_vm.genus))])]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "time-wrapper"
  }, [_c('span', {
    staticClass: "time -online"
  }, [_c('span', {
    staticClass: "pictogram"
  }), _vm._v(" "), (_vm.clearPublishDateTime) ? _c('time', {
    staticClass: "text-muted",
    attrs: {
      "datetime": _vm.publishDateTime
    }
  }, [_vm._v(_vm._s(_vm.clearPublishDateTime))]) : _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('span', {
    staticClass: "time -offline"
  }, [_c('span', {
    staticClass: "pictogram"
  }), _vm._v(" "), (_vm.clearOfflineDateTime) ? _c('time', {
    staticClass: "text-muted",
    attrs: {
      "datetime": _vm.offlineDateTime
    }
  }, [_vm._v(_vm._s(_vm.clearOfflineDateTime))]) : _c('span', {
    staticClass: "text-muted"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "objectid text-muted"
  }, [_vm._v(_vm._s(_vm.objectId))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23cc79ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoObjectCard.vue
// module id = 606
// module chunks = 0